import React, { useState } from "react";
import PropTypes from "prop-types";
import { Formik, Form, Field, FieldArray } from "formik";
import TextField from "@material-ui/core/TextField";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CloseIcon from "@material-ui/icons/Close";
import Modal from "react-bootstrap/Modal";
import { Button, Radio } from "@material-ui/core";
import FormStepper from "../FormStepper";
import axios from "axios";
import { DatePicker } from "../../Pers-atoms";

export const Status = ({
  formData,
  setFormData,
  nextStep,
  prevStep,
  step,
  persId,
  projectId,
}) => {
  // let [persStatus, setPersStatus] = React.useState("");
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const passData = JSON.parse(sessionStorage.getItem("passData"));
  const [disable, setDisable] = useState(false);
  let [persDecisionData, setPersDecisionData] = React.useState("");
  let [persStatus, setPersStatus] = React.useState("");
  let [expirationList, setExpirationList] = React.useState([]);
  const fetchPersDecisionData = React.useCallback(() => {
    axios
      .get(
        global.REACT_APP_API_ENDPOINT + `/decision/getPersDecisionAndExpiration`
      )
      .then((response) => {
        setPersDecisionData(response.data);
      })
      .catch((error) => {
        throw Error(error);
      });
  }, []);

  React.useEffect(() => {
    // fetchPersStatusData();
    fetchPersDecisionData();
  }, [fetchPersDecisionData]);

  const persStatusList = Object.keys(persDecisionData).map((key) => key);

  function statusChanged(event, data) {
    setExpErr("");
    setDateErr("");
    setApiErr("");
    setStatusErr("");

    setPersStatus(event.target.value);

    if (event.target.value != "") {
      Object.keys(persDecisionData).map((key) => {
        if (key == event.target.value) {
          setExpirationList(persDecisionData[key]);
        }
      });
    } else {
      setExpirationList([]);
    }

    console.log("expirationList", expirationList);

    setTimeout(() => {
      // checkPersDecisionValidation(data);
    }, 500);
  }

  function expirationChanged(data) {
    setApiErr("");

    if (!data.persExpiration) {
      setExpErr("Required");
    } else {
      setExpErr("");
    }
  }

  function specificDateChanged(data) {
    setApiErr("");

    if (!data.dtSpecificDate) {
      setDateErr("Required");
    } else {
      setDateErr("");
    }
  }

  const [apiErr, setApiErr] = useState("");
  const [emptyErr, setEmptyErr] = useState("");

  const [statusErr, setStatusErr] = useState("");
  const [expErr, setExpErr] = useState("");
  const [dateErr, setDateErr] = useState("");

  function savePersDecision(data) {
    setIsSubmitted(true);

    let statusErr = "";
    let dateErr = "";
    let expErr = "";

    if (!persStatus) {
      statusErr = "Required";
    }

    if ((!data.persExpiration) && (persStatus === "Final Project Approval" || persStatus === "Conditional/Available" || persStatus === "Conditional/Unavailable")) {
      expErr = "Required";
    }

    if (data.persExpiration === "Enter Specific date") {
      dateErr = getDateError(data.dtSpecificDate);
    }

    setStatusErr(statusErr);
    setDateErr(dateErr);
    setExpErr(expErr);

    if (!statusErr && !dateErr && !expErr) {
      if (data.projectReasonError === 'valid' || persStatus !== "Ineligible" && persStatus !== "Conditional/Unavailable") {
        checkRedirection(data);
      }
    }
  }

  function callSaveDecision(data) {
    let params = {
      createdById: passData.user,
      persId: persId,
      persDecison: persStatus,
      persExpiration: data.dtSpecificDate
        ? data.dtSpecificDate
        : data.persExpiration,
      projectId: projectId,
      reviewedBy: "Test reviewer",
    };

    console.log("params =>> ", params);
    axios
      .post(
        global.REACT_APP_API_ENDPOINT + `/saveEstablishedPersDecision`,
        params
      )
      .then((response) => {
        console.log("save decision response", response);
        if (response.status == 200) {
          setApiErr("");
          setTimeout(() => {
            nextStep();
          }, 300);
        } else if (response.data && response.data.message) {
          if (response.data.message == "Internal server error") {
            window.location.href = "/error-page";
          } else {
            setApiErr(response.data.message);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Formik
        initialValues={formData}
        onSubmit={(values) => {
          // setFormData(values);
          // direction === 'back' ? prevStep() : nextStep();
        }}
      >
        {({ values, errors, touched }) => (
          <Form className="parent-form">
            <FormStepper step={step} />
            <div className="field-container">
              <div className="top-title-container">
                <div className="big-title">Add Established PERS Request</div>
                <div className="small-title">
                  For Condo Project: {values.projectId}
                </div>
              </div>

              <div className="success-lower-container">
                <div className="section-title">
                  Section 7 of 9 - PERS Decision : Overall Project
                </div>
                <div className="attribute-title">
                  PERS Decision<span style={{ color: "red" }}>*</span>
                </div>
                <div className="attribute-select">
                  <select
                    // required
                    name="persStatus"
                    id={"id"}
                    className="attribute-select-dropdown select-decision"
                    value={persStatus}
                    onChange={(event) => {
                      values.persStatus = event.target.value;
                      values.persExpiration = "";
                      statusChanged(event, values);
                    }}
                  >
                    <option value="">Select PERS Status</option>
                    {persStatusList.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  {statusErr ? (
                    <div style={{ color: "red" }}>{statusErr}</div>
                  ) : null}
                  {/* {errors.persStatus && touched.persStatus ? <div style={{ color: "red" }}>{errors.persStatus}</div> : null} */}
                </div>
                <div className="attribute-title">
                  Expiration<span style={{ color: "red" }}>*</span>
                </div>
                <div className="attribute-select">
                  {persStatus == "Ineligible" ||
                  persStatus == "Suspension of the Application" ? (
                    <div>{(values.persExpiration = "NA")}</div>
                  ) : (
                    // <Field
                    //   className="attribute-select-dropdown"
                    //   name="persExpiration"
                    //   as="select"
                    //   validate={validateText}
                    // >
                    <select
                      // required
                      name="persExpiration"
                      id={"id"}
                      className="attribute-select-dropdown select-decision"
                      value={values.persExpiration}
                      onChange={(event) => {
                        values.persExpiration = event.target.value;
                        values.dtSpecificDate = "";

                        setFormData((prevExpiry) => ({
                          ...prevExpiry,
                          values,
                        }));
                        expirationChanged(values);
                      }}
                    >
                      <option value="">Expiration</option>
                      {expirationList
                        ? expirationList.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        : null}
                    </select>
                    // {/* </Field> */}
                  )}

                  {expErr ? <div style={{ color: "red" }}>{expErr}</div> : null}
                </div>
                <div className="attribute-select">
                  {values.persExpiration === "Enter Specific date" && (
                    <div className="field">
                      <DatePicker
                        label=""
                        name="dtSpecificDate"
                        formData={formData}
                        handleChange={(e) => {
                          let value = e.target.value;
                          if (value === '') {
                            value = null;
                          }
                          values.dtSpecificDate = value;

                          setFormData((prevExpiry) => ({
                            ...prevExpiry,
                            values,
                          }));

                          specificDateChanged(values);
                        }}
                        isEdit
                      />
                    </div>
                  )}
                  {dateErr ? (
                    <div style={{ color: "red" }}>{dateErr}</div>
                  ) : null}
                </div>

                <div
                  style={{
                    textAlign: "right",
                    color: "#ff0000",
                    padding: 15,
                  }}
                >
                  {apiErr ? apiErr : null}
                </div>
                <div className="bottom-button-container">
                  <Button
                    type="submit"
                    className="next-button next-btn-save"
                    disabled={disable}
                    onClick={() => {
                      setDisable(true);
                      savePersDecision(values);
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    type="submit"
                    className="next-button next-btn-save"
                    onClick={() => {
                      nextStep();
                    }}
                  >
                    Skip
                  </Button>
                </div>
              </div>
            </div>
            <div className="right-cancel-container">
              <Button className="cancel-pers-button" onClick={handleShow}>
                <CloseIcon style={{ fill: "red" }} />
                Cancel PERS Request
              </Button>
              <Modal show={show} className="my-modal" onHide={handleClose}>
                <Modal.Header className="the-modal-header" closeButton>
                  <Modal.Title className="the-modal-title">
                    Cancel PERS Request
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="the-modal-body">
                  All of your progress will be lost. Are you sure you want to
                  cancel?
                </Modal.Body>
                <Modal.Footer className="the-modal-footer">
                  <Button className="go-back-button" onClick={handleClose}>
                    Go Back
                  </Button>
                  <Button className="cancel-modal-button" href={`/`}>
                    Cancel PERS Request
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

Status.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
};
